import { Observable } from 'rxjs';

import { ConsentForm } from '../models/consent-form.model';

export abstract class ConsentFormUsecase {
  abstract get consentForms$(): Observable<ConsentForm[]>;

  abstract listConsentForms(): Observable<never>;
}
